import addFilesToCollectionStyles from 'features/media/AddFilesToCollection/addFilesToCollectionStyles';
import { faFolderOpen, faPlusSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from 'shared/components/display';
import Modal from 'shared/components/molecules/Modal';
import { COLLECTION_COPY } from 'shared/config/copy';
import { SIZING } from 'shared/config/formatting';
import { COLLECTION_TOASTS } from 'shared/config/toasts/collectionToasts';
import { BUTTON_VARIANTS } from 'shared/styles/button';
import React, { useMemo, useState } from 'react';
import { Button } from 'rebass/styled-components';
import MoveFilesToCollectionForm from 'features/media/components/organisms/MoveFilesToCollectionForm';
import { useToasts } from 'shared/hooks/useToasts';
import { intl } from 'shared/lib/intl';
import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { BrkfstFile } from 'shared/typings/file';

interface Props {
  selectedFiles: BrkfstFile[];
  collectionId: number;
}

const AddFilesToCollection: React.FC<Props> = ({ selectedFiles = [], collectionId }) => {
  const [open, setOpen] = useState(false);
  const { setErrorToast } = useToasts();

  const selectedFileIds = useMemo(() => {
    return selectedFiles.map(({ id }) => id);
  }, [selectedFiles]);

  const toggleModal = () => {
    setOpen((prev) => !prev);
  };

  const setError = (err) => {
    setErrorToast({ message: err });
  };

  return (
    <>
      <Box className="add-files-to-collection" css={addFilesToCollectionStyles}>
        <Tooltip
          content={intl.formatMessage(
            { id: 'TOOLTIP_MOVE_FILES' },
            {
              numFiles: selectedFileIds.length,
            },
          )}
        >
          <Button
            variant={BUTTON_VARIANTS.SECONDARY}
            className="add-files-to-collection__btn"
            onClick={
              !selectedFileIds.length
                ? () => setError(COLLECTION_TOASTS.ADD_TO_COLLECTION_NOT_ENOUGH_ASSETS)
                : toggleModal
            }
          >
            <FontAwesomeIcon icon={faFolderOpen} />
          </Button>
        </Tooltip>
      </Box>
      <Modal
        title={COLLECTION_COPY.DRAWER_ADD_FILES}
        isOpen={open}
        onRequestClose={toggleModal}
        modalSize={SIZING.MEDIUM}
        component={
          <Box className="add-files-to-collection" css={addFilesToCollectionStyles}>
            <MoveFilesToCollectionForm
              selectedAssetIds={selectedFileIds}
              collectionId={collectionId}
              onSubmit={toggleModal}
            />
          </Box>
        }
      />
    </>
  );
};

export default AddFilesToCollection;
